'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findIcons = exports.setIconPopupMode = undefined;

var _elementIconService = require('../../../../../components/elementIcon/elementIconService');

var _iconsPopupConstants = require('./iconsPopupConstants');

var setIconPopupMode = exports.setIconPopupMode = function setIconPopupMode(_ref) {
    var mode = _ref.mode,
        id = _ref.id;
    return {
        type: _iconsPopupConstants.ICON_POPUP_MODE_SET,
        mode: mode,
        id: id
    };
};

var findIcons = exports.findIcons = function findIcons(_ref2) {
    var query = _ref2.query,
        id = _ref2.id;
    return function (dispatch, getState) {
        dispatch({ type: _iconsPopupConstants.ICON_POPUP_SEARCH_SUBMIT, query: query, id: id });

        (0, _elementIconService.searchForIcon)(query, 16).then(function (response) {
            var icons = response.data.icons;

            dispatch({ type: _iconsPopupConstants.ICON_POPUP_SEARCH_SUCCESS, query: query, icons: icons });
        }).catch(function (err) {
            console.error('ERROR: Retrieving icons.', err, err.response);
            dispatch({ type: _iconsPopupConstants.ICON_POPUP_SEARCH_FAILURE, query: query });
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/iconsPopupActions.js
// module id = 790
// module chunks = 0